<template>
  <div class="relative self-stretch" @mouseleave="isOpen = false">
    <div @mouseover="isOpen = true" class="h-full self-stretch">
    <slot name="title" class="absolute self-stretch"></slot>
    </div>
    <div v-if="isOpen" class="absolute bg-white text-trader-text shadow-lg w-40 shadow-trader-darkest-gray z-20" :class="{'right-0' : bindRight }" @click="isOpen = false">
      <slot name="menu"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropDown",
  props: {
    bindRight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  }
}
</script>
